import React from "react";
import { useApp, LANGS, CURRENCIES_LIST } from "@/context/AppContext";
import { Globe, DollarSign } from "lucide-react";

export function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useApp();
  return (
    <div className="relative" data-testid="lang-switcher">
      <Globe size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none" />
      <select
        className="field pl-7 pr-6 py-1 text-xs bg-hover appearance-none"
        value={lang}
        onChange={(e) => setLang(e.target.value)}
      >
        {LANGS.map((l) => (
          <option key={l.code} value={l.code}>
            {compact ? `${l.flag} ${l.code.toUpperCase()}` : `${l.flag} ${l.label}`}
          </option>
        ))}
      </select>
    </div>
  );
}

export function CurrencySwitcher({ compact = false }) {
  const { currency, setCurrency } = useApp();
  return (
    <div className="relative" data-testid="currency-switcher">
      <DollarSign size={12} className="absolute left-2 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none" />
      <select
        className="field pl-7 pr-6 py-1 text-xs bg-hover appearance-none"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
      >
        {CURRENCIES_LIST.map((c) => (
          <option key={c.code} value={c.code}>
            {compact ? `${c.symbol} ${c.code}` : `${c.symbol} ${c.code} — ${c.label}`}
          </option>
        ))}
      </select>
    </div>
  );
}
